import { capitalize, computed } from 'vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { EnumDocumentType } from '@getaccept/lib-shared/src/enums/DocumentType';
import { useAppMode } from '../../composables/app-mode.composable';

export const useDocumentTypes = (hasSignatureField?: boolean) => {
  const { isSales } = useAppMode();

  const salesDocumentOptions = computed(() => [
    {
      label: capitalize(t('sales')),
      type: EnumDocumentType.Sales,
      dataExternal: 'document-type-select-sales-option',
    },
    {
      label: capitalize(t('cr_non_signable_document')),
      type: EnumDocumentType.Introduction,
      dataExternal: 'document-type-select-introduction-option',
      disabled: hasSignatureField,
      tooltip: hasSignatureField ? t('document_signing_settings_disabled_tooltip') : '',
    },
    {
      label: capitalize(t('hr')),
      type: EnumDocumentType.Hr,
      dataExternal: `document-type-select-hr-option`,
    },
    {
      label: capitalize(t('other')),
      type: EnumDocumentType.Other,
      dataExternal: 'document-type-select-other-option',
    },
  ]);

  const businessDocumentOptions = computed(() => [
    {
      label: capitalize(t('contract')),
      type: EnumDocumentType.Hr,
      dataExternal: `document-type-select-contract-option`,
    },
    {
      label: capitalize(t('cr_non_signable_document')),
      type: EnumDocumentType.Introduction,
      dataExternal: 'document-type-select-introduction-option',
      disabled: hasSignatureField,
      tooltip: hasSignatureField ? t('document_signing_settings_disabled_tooltip') : '',
    },
    {
      label: capitalize(t('other')),
      type: EnumDocumentType.Other,
      dataExternal: 'document-type-select-other-option',
    },
  ]);

  const documentTypes = computed(() =>
    isSales.value ? salesDocumentOptions.value : businessDocumentOptions.value
  );

  return {
    documentTypes,
    salesDocumentOptions,
    businessDocumentOptions,
    isSales,
  };
};
